import React, { useState, useEffect } from "react"
import Offcanvas from 'react-bootstrap/Offcanvas'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import TooltipX from 'react-bootstrap/Tooltip'
import QRWebScan from "./QRWebAndNativeScan"



export default function XAccess(props) {
    const [showCanvas, setShowCanvas] = useState(false);
    const [xState, setXState] = useState(0);
    const handleCloseCanvas = () => setShowCanvas(false);
    const handleOpenCanvas = () => setShowCanvas(true);

    useEffect(() => {
        // xState effect logic
    }, [xState])


    return (
        <>
            {/* Click button at the top remains unchanged */}
            <OverlayTrigger overlay={<TooltipX>Access Logs</TooltipX>}>
                <Button variant="primary" onClick={handleOpenCanvas} className=" animated rollIn hoverX">
                       <span className="circle-btn centerCircle">🔒</span>
                     Access
                </Button>
            </OverlayTrigger>

            <Offcanvas show={showCanvas} onHide={handleCloseCanvas} backdropClassName="adminBackdrop" className="bg-dark" placement="end" >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <h3 className="modified xTitle animated rollIn">
                            Access
                        </h3>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <QRWebScan></QRWebScan>
                 
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}